import {
    authorizedSyliusFetch,
    Token,
    tokenKey,
    UpdateCustomerPasswordResponse,
} from '../../../entities/@api/Sylius';
import { ChangePasswordFormData } from '../../../entities/@forms/ChangePasswordForm/ChangePasswordForm';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import trans from '../../../helpers/trans';
import { ReduxFetchAction } from '../../defaults';
import { addPositiveToast } from '../../toast/toastActions';
import { setError, setHasChangedSuccessfully, setIsLoading } from './changePasswordSlice';

export const changePassword: ReduxFetchAction<ChangePasswordFormData> = formData => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setError(''));
    dispatch(setHasChangedSuccessfully(false));

    try {
        const storedToken = localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);
        const tokenData = storedToken
            ? JSON.parse(storedToken) as Token
            : undefined;

        const customerId = tokenData?.customerId || '';

        const changePasswordResponse = await authorizedSyliusFetch<UpdateCustomerPasswordResponse>(`/shop/customers/${customerId}/password`, {
            method: 'PUT',
            body: JSON.stringify(formData),
        });

        if (!isFetchResultSuccessful(changePasswordResponse)) {
            dispatch(setError(changePasswordResponse.error));
            return;
        }

        dispatch(setHasChangedSuccessfully(true));

        dispatch(addPositiveToast({
            title: trans('redux.changePassword.successMessageTitle'),
            description: trans('redux.changePassword.successMessageDescription'),
        }));
    } catch (error) {
        console.error('[changePassword]', error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
